export function resetDocumentScroll(windowObject = window, documentObject = document) {
  windowObject.scrollTo({top: 0, left: 0, behavior: 'auto'});

  if (documentObject?.documentElement) {
    documentObject.documentElement.scrollTop = 0;
    documentObject.documentElement.scrollLeft = 0;
  }

  if (documentObject?.body) {
    documentObject.body.scrollTop = 0;
    documentObject.body.scrollLeft = 0;
  }
}
